import React from 'react'
import { ReactComponent as MenuIcon } from 'assets/img/brackets.svg'
import FlexyPopOnMe from 'elements/flexypoponme';
import styles from "./communityMergeTags.module.scss"


const CommunityMergeTags = (
    {
        mergeTags,
        handleTagClick,
        menuIconStyles,
    }: {
        mergeTags: any,
        handleTagClick: any
        menuIconStyles: string,
    }
) => {
    return (
        <FlexyPopOnMe
            closeOnComponentClick
            placement='bottom-end'
            hideTippyArrow
            component={
                <div className={styles.mergeTagsPopUp}>{
                    mergeTags.length > 0 && mergeTags.map((tag: any, index: number) => {
                        return (
                            <div className={styles.mergeTagContent} onClick={() => handleTagClick(tag.value)}>
                                <h1>{tag.name}</h1>
                                <span>{tag.value}</span>
                            </div>
                        )
                    })
                }
                </div>
            }
        >
            <div className={`${styles.menuIcon} ${menuIconStyles}`}>
                <MenuIcon />
            </div>
        </FlexyPopOnMe>
    )
}

export default CommunityMergeTags